import * as Sentry from '@sentry/browser';
import config from '@nerdwallet/app-config';
import { isEventExcluded } from './isEventExcluded';
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? 'FIXMENEEDSVERSIONINFO' : _ref$version;

  if (process.browser && config.CONFIG_ENV !== 'development' && config.SENTRY_DSN // this will be referencing BROWSER.SENTRY_DSN in app-config
  ) {
    var _config$_meta$version, _config$_meta;

    Sentry.init({
      dsn: config.SENTRY_DSN,
      environment: config.CONFIG_ENV,
      // eslint-disable-next-line no-underscore-dangle
      release: (_config$_meta$version = config === null || config === void 0 ? void 0 : (_config$_meta = config._meta) === null || _config$_meta === void 0 ? void 0 : _config$_meta.version) !== null && _config$_meta$version !== void 0 ? _config$_meta$version : version,
      beforeSend: function beforeSend(event) {
        if (isEventExcluded(event)) {
          return null;
        }

        return event;
      }
    });
  }
});